export interface IMonitorOrganization {
  id: number
  slug: string
  title: string
  url: string
  logo: string
}

export interface IMonitorCreditProduct {
  id: number
  title: string
  url: string
  rate: number
}

export interface IMonitorCreditRateItem {
  organization: IMonitorOrganization
  rate: number
  min: number
  max: number
  products: number
  credits: IMonitorCreditProduct[]
}

export interface IMonitorCreditPeriod {
  period: number
  organizations: number
  is_visible: boolean
}

export interface IMonitorCreditRatesMeta {
  type: string
  type_title: string
  currency: string
  period: number | null
  periods: IMonitorCreditPeriod[]
  min_banks: number
  is_visible: boolean
  organizations: number
  products: number
  market_avg: number | null
  market_min: number | null
  market_max: number | null
  updated_at: string
}

export interface IMonitorCreditRatesResponse {
  data: IMonitorCreditRateItem[]
  meta: IMonitorCreditRatesMeta
}

export interface IMonitorDepositProduct {
  id: number
  title: string
  url: string
}

export interface IMonitorDepositRateItem {
  organization: IMonitorOrganization
  rate: number
  products: number
  deposit: IMonitorDepositProduct
}

export interface IMonitorDepositRatesResponse {
  data: IMonitorDepositRateItem[]
}

export interface IMonitorNbkrPoint {
  month: string
  rate: number
  // NBKR omits the corridor for every table we consume, so these stay null.
  min: number | null
  max: number | null
  volume: number
  preliminary: boolean
}

export interface IMonitorNbkrLastMonth {
  month: string
  rate: number
  preliminary: boolean
}

export interface IMonitorNbkrMeta {
  product: string
  category: string | null
  nbkr_category: string
  term: string
  range: string
  currency: string
  source: string
  source_table: string
  has_range: boolean
  last_month: IMonitorNbkrLastMonth
  points_total: number
  points_shown: number
  updated_at: string
}

export interface IMonitorNbkrResponse {
  data: {
    points: IMonitorNbkrPoint[]
  }
  meta: IMonitorNbkrMeta
}

export type MonitorNbkrRange = '6m' | '1y' | '2y' | '3y' | 'all'

// Credit types that have a matching sector in the NBKR statistics tables.
// `autos` and `subsidized` are absent there, so the dynamics block is hidden for them.
export const MONITOR_NBKR_CREDIT_CATEGORIES = ['consumer', 'mortgage', 'business'] as const

export type MonitorNbkrCreditCategory = (typeof MONITOR_NBKR_CREDIT_CATEGORIES)[number]
